<div [class]="{ 'loading-container': !small, 'loading-container-small': small}">
    <div>
        <div class="icon">
            <mat-progress-spinner mode="indeterminate" [diameter]="small? 20 : 150"></mat-progress-spinner>
        </div>
        @if (!small) {
            <div class="spinner-wording">
                <span>{{ message | translate }}</span>
            </div>
        }
    </div>
</div>